// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.manage-tags-modal__loading {
  z-index: 10;
}
.manage-tags-modal__body {
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.manage-tags-modal__wrapper {
  min-height: 0;
}
.manage-tags-modal__section {
  min-height: 0;
}
.manage-tags-modal__error {
  color: var(--color-error-content-base);
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/tags/ui/ManageTagsModal.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,WAAA;AAQJ;AALE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAOJ;AAJE;EACE,aAAA;AAMJ;AAHE;EACE,aAAA;AAKJ;AAFE;EACE,sCAAA;EACA,eAAA;AAIJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.manage-tags-modal {\n  &__loading {\n    z-index: 10;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n  }\n\n  &__wrapper {\n    min-height: 0;\n  }\n\n  &__section {\n    min-height: 0;\n  }\n\n  &__error {\n    color: var(--color-error-content-base);\n    font-size: @fontSize-xs;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
